import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { listBookCategoriesQueryKey } from "@modules/bookCategories/services/queries";
import { useCreateBookCategoryMutation } from "@modules/bookCategories/services/mutations";
import { BookCategoryFormValues, bookCategorySchema } from "@modules/bookCategories/validations";

export function useCreateBookCategoryModal(modalRef: RefObject<ModalRef>, onComplete?: () => void) {
  const queryClient = useQueryClient();
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<BookCategoryFormValues>({
    resolver: zodResolver(bookCategorySchema()),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useCreateBookCategoryMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listBookCategoriesQueryKey,
        refetchType: 'all',
      });

      open?.({
        type: "success",
        message: translate("book_category_admin.success.create"),
      });

      onComplete?.();
      modalRef.current?.close();
    },
  });


  return {
    methods,
    mutateAsync,
    isPending,
  };
}
